import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { useCompositorView } from '@/components/Recipe/FlowContext';
import { LayerPropertyPanelField } from './LayerPropertyPanelField';
import { NumberInput } from './NumberInput';
import { layerProperties } from './layerProperties';
import { FlipLayerButtons } from './FlipLayerButtons';
import type { Layer, LayerId, NodeId } from 'web';

export function RotationControlsRow({ nodeId, layerId, layer }: { nodeId: NodeId; layerId: LayerId; layer: Layer }) {
  const { t } = useTranslation();
  const compositorView = useCompositorView(nodeId);
  const prop = layerProperties.rotation;
  const value = prop.getValue(layer);
  const onSubmit = useCallback(
    (v: number) => {
      prop.setValue(compositorView, layerId, v);
    },
    [compositorView, layerId, prop],
  );

  return (
    <LayerPropertyPanelField label={t(I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ROTATION)}>
      <Flex sx={{ gap: 0.5, alignItems: 'center', flexWrap: 'wrap', flexShrink: 1 }}>
        <NumberInput
          value={value}
          onSubmit={onSubmit}
          disabled={layer.locked}
          prefix={prop.label}
          unit={prop.unit}
          format={prop.format}
          parse={prop.parse}
          decimals={prop.decimals}
        />
        <FlipLayerButtons nodeId={nodeId} layerId={layerId} layer={layer} />
      </Flex>
    </LayerPropertyPanelField>
  );
}
